export default {
  'YouTube and High Definition Videos': 'Youtubeと高画質な動画',
  'Story videos (Instagram/Snaps/TikTok)': 'ストーリー動画（Instagram/SNaps/TikTok）',
  'Facebook and Instagram Feed videos': 'FacebookとInstagramのフィード動画',
  'Facebook and Twitter Portrait Videos': 'FcebookとTwitterのポートレート動画',
  'Twitter and Facebbok Landscape Videos': 'TwitterとFacebookの横向き動画',
  'Facebook Cover Videos And Blog Banners': 'Facebookカバー動画とブログバナー',
  'Fit': 'フィット',
  'Fill': '塗りつぶし',
}